import React, { ReactElement } from "react";
import { setAppSettingsData } from "../context/data/appSettings.actions";
import { LoginState } from "../context/data/login.state";
import {
  loadOrdersDataAction,
  saveOrderDataAction,
} from "../context/data/orders.actions";
import { bagOrderSetStatus } from "../context/data/api";

interface OrderTimeProps {
  saveOrderDataAction: typeof saveOrderDataAction;
  login: LoginState;
  order: any;
  setAppSettingsData: typeof setAppSettingsData;
  loadOrdersDataAction: typeof loadOrdersDataAction;
}

export default function OrderTime({
  saveOrderDataAction,
  login,
  order,
  setAppSettingsData,
  loadOrdersDataAction,
}: OrderTimeProps): ReactElement {
  const timesToSelect = [20, 30, 40, 50, 60, 70, 80, 90];

  const save = async (msg: string) => {
    try {
      // Call API directly to get the result
      const result = await bagOrderSetStatus(order.bagGuid, msg, login);

      if (result.success) {
        // Only reload orders and redirect if save was successful
        // IMPORTANT: Change view FIRST, then reload orders
        // This prevents components from crashing when orders list is cleared
        setAppSettingsData({ view: "orders" });
        loadOrdersDataAction(true, login);
      } else {
        // Show error alert if save failed
        alert(result.error || "Failed to update order. Please try again.");
      }
    } catch (error: any) {
      // Catch any unexpected errors
      console.error("Error saving order:", error);
      alert("An error occurred while updating the order. Please try again.");
    }
  };

  return (
    <div>
      <div className="timesContainer">
        {order.isFutureOrder === 0 &&
          timesToSelect.map((t) => (
            <button key={t} type="button" onClick={() => save(t.toString())}>
              {t} min
            </button>
          ))}
        {order.isFutureOrder === 1 && (
          <button
            className="fullButton"
            type="button"
            onClick={() => save("Accept")}
          >
            Accept
          </button>
        )}
        <button
          className="fullButton"
          type="button"
          onClick={() => save("Reject")}
        >
          Reject
        </button>
      </div>
    </div>
  );
}
